import { useFormikContext } from "formik";
import React, { FC, useEffect, useState } from "react";
import { DEF_PG_SIZE_WIZARD } from "../../constants/maximum-page-size";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import { useLocale } from "../../contexts/localeContext";
import { TableContextProvider } from "../../contexts/table/TableContextProvider";
import ReportColumns from "../../models/ColumnDefinitions/ReportColumn";
import { Report } from "../../models/Report";
import ReportSearch from "../../models/search/ReportSearch";
import { removeColumns } from "../../models/utilities/columnHelper";
import { getAllReport } from "../../services/reportService";
import TableTab from "../tabs/table-tab";
import { appendFilter } from "../../utilities/filters";
import { ReportSubTypes } from "../../constants/report-types";
import { WizardStepLayout } from "../wizard/wizard-summary-layout";

interface ReportStepProps {
    onBack: (event: any) => void;
    onNext: (event: any) => void;
    setDescription: (discription: string) => void;
}

const ReportStep: FC<ReportStepProps> = ({ onNext, onBack, setDescription = () => { } }) => {
    const [taskSelected, setTaskSelected] = useState(false);
    const { translate } = useLocale();
    const { setFieldValue } = useFormikContext<any>();
    const [report, setReport] = useState<Report>({
        id: 0,
        name: '',
        typeId: ""
    });

    useEffect(() => {
        if (taskSelected) {
            const buttonEvent = {} as React.MouseEvent<HTMLButtonElement, MouseEvent>;
            onLocalNext(buttonEvent)
        }
    }, [taskSelected])

    const onLocalNext = (event: any) => {
        if (taskSelected) {
            onNext({ ...event });
            setDescription(report.name)
            setFieldValue("reportId", report.id);
            setFieldValue("report", report.nameOriginal);
        }
    }

    const itemSelected = (selectedItem: any) => {
        if (selectedItem) {
            setReport({ ...selectedItem });
            setTaskSelected(true);
            onNext({}); //fake event
            setTaskSelected(false);
            setDescription(selectedItem.nameOriginal);
            setFieldValue("reportId", selectedItem.id);
            setFieldValue("report", selectedItem.nameOriginal);
        }
    }

    const filterToNameOnly = searchDescriptor => {
        return searchDescriptor.filter(item => item.accessor === 'name');
    };

    // remove vingcard from notifications selections.
    const filteredGetAllReport = (listParameters) => {
        return getAllReport({ ...listParameters, filters: appendFilter(false, 'Report supported for scheduling', 'supportedForScheduling',[], "=out=") });
    };

    return (
        <WizardStepLayout onBack={onBack} onNext={onLocalNext} nextDisabled={!taskSelected}>
            <div className="pl-3">
                <TableContextProvider
                    usePagination
                    useTable
                    useFilter
                    useSearch
                    dataMethod={filteredGetAllReport}
                    maxPageSize={DEF_PG_SIZE_WIZARD}
                    tableDescriptor={removeColumns(ReportColumns, ['type', 'description', 'createdBy', 'siteName'])}
                    searchDescriptor={filterToNameOnly(ReportSearch)}
                    disableSearch={false}
                    canExportReport={false}>
                    <TableTab
                        title={translate.byKey(TranslationKeys.selectTheReport)}
                        selectRows={false}
                        onRowClicked={(data) => (itemSelected(data))}
                        tableId={'reportNotificationTable'}
                        style={{ maxHeight: "calc(100% - 70px)" }}
                        cyName="reportNotification"
                    />
                </TableContextProvider>
            </div>
        </WizardStepLayout>
    )
}

export default ReportStep;
